// import types from './types';

import PaymentActionTypes from './types';

export const fetchConsignerPaymentDetailsStart = (payload: any) => ({
  type: PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_START,
  payload: payload,
});

export const fetchConsignerPaymentDetailsSuccess = (payload: any) => ({
  type: PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_SUCCESS,
  payload: payload,
});

export const fetchConsignerPaymentDetailsFailure = (payload: any) => ({
  type: PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_FAILURE,
  payload: payload,
});

export const fetchConsignerDocumentStart = (payload: any) => ({
  type: PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_START,
  payload: payload,
});

export const fetchConsignerDocumentSuccess = (payload: any) => ({
  type: PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_SUCCESS,
  payload: payload,
});

export const fetchConsignerDocumentFailure = (payload: any) => ({
  type: PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_FAILURE,
  payload: payload,
});

export const initiateConsignerPaymentStart = (payload: any) => ({
  type: PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_START,
  payload: payload,
});

export const initiateConsignerPaymentSuccess = (payload: any) => ({
  type: PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_SUCCESS,
  payload: payload,
});

export const initiateConsignerPaymentFailure = (payload: any) => ({
  type: PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_FAILURE,
  payload: payload,
});

export const initiateConsignerPaymentStatusStart = (payload: any) => ({
  type: PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_START,
  payload: payload,
});

export const initiateConsignerPaymentStatusSuccess = (payload: any) => ({
  type: PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_SUCCESS,
  payload: payload,
});

export const initiateConsignerPaymentStatusFailure = (payload: any) => ({
  type: PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_FAILURE,
  payload: payload,
});
